import React, {Component} from 'react';
import {HashLink} from 'react-router-hash-link'
import {Link} from "react-router-dom";

import './About.css';
import './Overlay.css';

export default class About extends Component {
  render() {
    return (
      <div id="about" className="overlay">
        <div className="ui">
          <Link className="link close" to="/">✕</Link>
        </div>
        <div className="content">
          <h2 id="about-what-is-this">What is this?</h2>
          <p>Just an experiment using Twitter data.</p>
          <p>It shows more or less which language is used the most on Twitter from each geographical location.</p>
          <h2 id="about-how">How?</h2>
          <p>By collecting tweets that have geolocation data, detecting their language and then counting for each
            location
            how many times each language had appeared. Then, performing some geometrical operations to expand the points
            into areas —basically.</p>
          <h2 id="about-why">Why?</h2>
          <p>I like maps, I guess —and especially those which go beyond the typical country boundaries and show a bit
            more of the human aspects below their surface.</p>
          <h2 id="how-accurate-is-this">How accurate is this?</h2>
          <p>Don't expect too much, for several reasons:</p>
          <ul>
            <li>Tweet location data seems to be very unprecise in some regions —for example, in the Balkans, or
              countries in
              and around the Sahara—, which provokes some alterations in the region shapes.
            </li>
            <li>Twitter is blocked in some countries, which affects the map e.g. in China, Cuba, and North Korea. This
              causes other languages to tend to win over the local ones in this map.
            </li>
            <li>Keep in mind that this data comes from Twitter, which introduces some biases. For example, the English
              language is so predominant in Twitter that I decided to compensate it somewhat artificially by manually
              limiting its boundaries (see <HashLink to="/about#about-layers">below</HashLink>).
            </li>
            <li>This map currently accounts for 131 different languages, as detected by the tools I used. This might
              seem like a
              good number, but it's still only a small fraction of the language diversity of the real world.
            </li>
            <li>Assigning boundaries to languages is always a tricky thing to do. Keep in mind that reality is usually
              richer and more complex, languages
              often overlap, and assigning only one language to a region is often a subjective decision with political
              connotations. To put it simply, here I basically came up with a simple algorithm which gives me a lazy
              answer (even though it took quite some work!).
            </li>
          </ul>
          <p>At the same time, though, you might find interesting regions to look at, especially multilingual ones:
            Belgium; the Catalan-speaking regions; the East and South of Africa; the Gulf of Guinea; India; Quebec;
            Wales...</p>
          <h2 id="about-layers">Why are there two layers named "Raw" and "Edited"?</h2>
          <p>In the "edited" map I have applied (rough) manual boundaries to certain languages, to help produce a
            "cleaner" map. In the "raw" map I only applied this technique to the English language, which would otherwise
            invade a lot of the map and make a lot of the diversity invisible.</p>
          <p>Both layers might get improved iterations as more data is collected over time.</p>
          <h2 id="about-how-much-data">How much data has been used?</h2>
          <p>At the moment more than 61 million tweets have been used to generate the map,
            which account for more than 418,000
            different locations.</p>
          <p>To collect all this data I have had a script running continuously for about five weeks, which continues to
            run.</p>
          <h2 id="about-dig-deeper">Can I dig deeper?</h2>
          <p>Sure, <a href="https://github.com/jperals/colors-of-twitter">here</a> you can find all my scripts so you
            can play yourself.</p>
          <h2 id="about=acknowledgements">Acknowledgments</h2>
          <p>This project holds obvious resemblance to Eric Fischer's <a
            href="https://flowingdata.com/2011/10/27/language-communities-of-twitter/"><em>Language Communities of
            Twitter</em></a>, from
            which it draws a big deal of the idea.</p>
          <p>Also, this was possible thanks to a bunch of free software projects like:</p>
          <ul>
            <li>Raymond Hills' <a href="http://www.raymondhill.net/voronoi/rhill-voronoi.html">Voronoi algorithm
              library</a>
            </li>
            <li>
              The <a href="https://www.npmjs.com/package/cld">Compact Language Detector</a>
            </li>
            <li>
              <a href="https://www.mongodb.com">MongoDB</a>
            </li>
            <li>
              <a href="http://turfjs.org/">Turf.js</a>
            </li>
            <li>
              <a href="https://nodejs.org">Node.js</a>
            </li>
            <li>And <a href="https://github.com/jperals/colors-of-twitter/blob/master/package.json#L29">many
              others...</a></li>
          </ul>
        </div>
        <div className="attribution">
          <span className="license">&copy; <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a></span>
          <span> </span>
          <a href="https://perals.io">Joan Perals</a>
        </div>
        <div className="date-line">
          <span className="date-text">Last updated: </span>
          <span className="date">February 17th, 2019</span>
        </div>
      </div>
    )
  }
}
